export default __webpack_public_path__ + "278156e41e0ad908cf7f841b17130502.woff2";